<template>
  <div class="main-body">
    <div class="header">患者人脸</div>
    <div class="out">

      <div class="search">
        <!--        <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>-->

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <el-table class="table" :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="名称"></el-table-column>

        <el-table-column label="头像" width="300">
          <template slot-scope="scope">
<!--            <img :src="'data:image/jpeg;base64,'+scope.row.faceImg" alt="图片未上传" width="100"/>-->

            <img :src="imgUrl+scope.row.imgPath" alt="图片未上传" width="100"/>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,
      imgUrl:this.$imgUrl,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getCreateTime(row) {
      return timefilters(row.createTime);
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'UserFace/InsPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          userType:1,
          userName:'',
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },



  }
}
</script>

<style scoped>

</style>
